import { ShowExternalContactRequestSchema, ShowExternalContactResponseSchema } from './show-external-contact.schema';
/**
 * Show External Contact Endpoint Contract
 * Retrieves a specific external contact by ID
 */ export const showExternalContactContract = {
    method: 'GET',
    path: '/api/v2/external-contact/:id',
    description: 'Retrieve a specific external contact by ID',
    requestSchema: ShowExternalContactRequestSchema,
    responseSchema: ShowExternalContactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'External contact not found'
        }
    }
};

//# sourceMappingURL=show-external-contact.contract.js.map